import { Price } from "@silversea-ssc/ui-components-react"
import { PriceResponseV2 } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import { FareContent } from "../sanity/sanity-types"
import { fareCodeLabel } from "./fare-code-label"
import { formatAmount } from "./localization"

export const toFormattedPriceValue = (faresContent: FareContent[], price: PriceResponseV2): Price => {
    if (O.isSome(price.price.originalTotal)) {
        return {
            type: "discounted" as const,
            fareLabel: fareCodeLabel(faresContent, price.fareCode),
            formattedOriginalAmount: formatAmount(price.price.originalTotal.value),
            formattedAmount: formatAmount(price.price.total),
        }
    }

    return {
        type: "price" as const,
        fareLabel: fareCodeLabel(faresContent, price.fareCode),
        formattedAmount: formatAmount(price.price.total),
    }
}
